/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */

var cssClassPrefix = 'il';
var FW_PREFIX = 'il-framework-component';
var CLOSE_BTN_HTML_CODE = '&#215;';
var DTV3_PAGINATION_DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
var GRID_PAGINATION_DEFAULT_PAGE_SIZES = [25, 50, 100, 250, 500];
var ENTER_KEY = {
  CODE: 13,
  CHAR_CODE: 13,
  VALUE: 'Enter'
};
var SPACE_KEY = {
  CODE: 32,
  CHAR_CODE: 32,
  VALUE: ' '
};

export { CLOSE_BTN_HTML_CODE, DTV3_PAGINATION_DEFAULT_PAGE_SIZES, ENTER_KEY, FW_PREFIX, GRID_PAGINATION_DEFAULT_PAGE_SIZES, SPACE_KEY, cssClassPrefix };
